import { InvoicePaymentModel } from "@GeriMed/Type/ApiModelsExt";
import { ApiParameter, get, post, ServiceResult } from "@insite/client-framework/Services/ApiService";

const apiUrl = "/api/v2/invoices";

export interface InvoicePaymentApiParameter {
    invoiceParameter: InvoicePaymentModel;
}

export async function invoicePayment(parameter: InvoicePaymentApiParameter) : Promise<{success: boolean}> {
    return post<InvoicePaymentModel,{success: boolean}>(`${apiUrl}`, parameter.invoiceParameter as InvoicePaymentModel);
}

